import React, { useState } from 'react';
import CreateForm from './CreateForm';
import ModifyForm from './ModifyForm';
import AssignForms from './AssignForms';
import { useUserLevel, AdminLevel } from '../../context/admin';
import type { EditableForm } from './CreateForm';

type OptionKey = 'create' | 'modify' | 'assign';

interface FormsProps {
  users: Array<any>;
  uid: string;
}

const Forms: React.FC<FormsProps> = ({ users, uid }) => {
  const { currentUserLevel } = useUserLevel();
  const [selectedOption, setSelectedOption] = useState<OptionKey | null>(null);
  const [editingForm, setEditingForm] = useState<EditableForm | null>(null);

  if (currentUserLevel === AdminLevel.USER) return null;

  const handleClose = () => { setSelectedOption(null); setEditingForm(null); };

  const handleEdit = (form: EditableForm) => { setEditingForm(form); setSelectedOption('create'); };

  const renderModal = () => {
    switch (selectedOption) {
      case 'create': return <CreateForm onClose={handleClose} editingForm={editingForm} />;
      case 'modify': return <ModifyForm onClose={handleClose} onEdit={handleEdit} />;
      case 'assign': return <AssignForms onClose={handleClose} uid={uid} users={users} />;
      default:       return null;
    }
  };

  const menuOptions: { key: OptionKey; label: string }[] =
    currentUserLevel === AdminLevel.SUPER_ADMIN
      ? [
          { key: 'create', label: 'Create Form' },
          { key: 'modify', label: 'Manage Forms' },
          { key: 'assign', label: 'Assign Forms' },
        ]
      : [{ key: 'assign', label: 'Assign Forms' }];

  return (
    <>
      <div className="dropdown">
        <label tabIndex={0} className="btn mx-2 btn-inactive">Forms</label>
        <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52 z-50">
          {menuOptions.map(opt => (
            <li key={opt.key} onClick={() => setSelectedOption(opt.key)}><a>{opt.label}</a></li>
          ))}
        </ul>
      </div>
      {selectedOption && renderModal()}
    </>
  );
};

export default Forms;
